import type { CMSLinkUrl } from '@/types/sanity'
import { getPath } from '@/utilities'
import { getLoginHref } from '@/utilities/auth'

type LinkAttributes = {
  href?: string
  additionalParams: {
    target?: string
    rel?: string
  }
}

export const getLinkAttributes = (
  link: CMSLinkUrl,
  isUserLoggedIn?: boolean,
): LinkAttributes => {
  const {
    isExternal,
    isModal,
    isAnchor,
    isLoginLink,
    nextweekmenu,
    jebbitQuizUrl,
    pageType,
    url,
  } = link

  const isJebbitQuiz = url === '/#jebbit_quiz'

  const payload: LinkAttributes = { href: '', additionalParams: {} }
  switch (true) {
    case nextweekmenu || isModal:
      payload.href = '#'
      break
    case isJebbitQuiz:
      payload.href = jebbitQuizUrl
      break
    case isExternal:
      payload.href = url
      break
    case isAnchor:
      payload.href = `#${url}`
      break
    case isLoginLink:
      payload.href = isUserLoggedIn ? '/account/logout' : getLoginHref()
      break
    default:
      payload.href = getPath(pageType, url)
      break
  }

  payload.additionalParams =
    isExternal || isJebbitQuiz
      ? {
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      : {}

  return payload
}
